import { render, staticRenderFns } from "./specific.vue?vue&type=template&id=4647efca&scoped=true&"
import script from "./specific.vue?vue&type=script&lang=js&"
export * from "./specific.vue?vue&type=script&lang=js&"
import style0 from "./specific.vue?vue&type=style&index=0&id=4647efca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647efca",
  null
  
)

export default component.exports